import route from '@/router'
import getters from '@/store/getters';
import { getToken, clearToken } from '@/function/function'
import { roleRoute } from '@/router/index.js'

// 无需登录页面：1-对外调查问卷，2-资产扫码
const noLogin = ['/satisfaction/external', '/assets/detail'];

// 根据用户重置路由
const userInfo = getters.user()
if (userInfo) {
  if (userInfo.type) {
    roleRoute(userInfo.type)
  }
}
route.beforeEach(async (to, from, next) => {
  document.title = to.meta.title ? to.meta.title : '暖心值'
  console.log(to.path)
  // 路由白名单
  if (noLogin.findIndex(url => url == to.path) >= 0) {
    next()
  } else {
    // 获取token
    let token = getToken()
    if (token) {
      let userData = getters.user()
      try {
        // 是否存在用户信息
        // if (!userData || !userData.uuid) {
        //   if (to.path != '/login') {
        //     clearToken()
        //     next('/login?' + new Date().getTime())
        //   } else {
        //     next()
        //   }
        // }
        // 存在用户信息 则跳转对应主页
        if (to.path === '/login' || to.path === '/') {
          if (userData.type === 2) {
            next({ path: '/family', replace: true })
          } else if (userData.type === 1) {
            next({ path: `/staff`, replace: true })
          } else {
            // 错误人员类型
            clearToken()
            next(`/login`)
          }
        } else{
          // 正常跳转
          next()
        }
      } catch (e) {
        clearToken()
        next(`/login`)
      }
    } else {
      try {
        // 不存在token
        if (to.path != '/login') {
          next({ path: '/login', replace: true })
        }
        next()
      } catch (e) {
        clearToken()
        next(`/login`)
      }
    }
  }
})

route.afterEach(async (to, from, next) => {
})



// WEBPACK FOOTER //
// ./src/permission.js